'use client';

import React from 'react';
import Icon from '@/components/ui/AppIcon';

const TrustIndicatorsSection = () => {
  const metrics = [
    {
      icon: 'TrophyIcon',
      value: '85%',
      label: 'Success Rate',
      description: 'Of transformations achieve or exceed ROI targets',
    },
    {
      icon: 'ClockIcon',
      value: '6-12',
      label: 'Months to ROI',
      description: 'Average time to measurable business outcomes',
    },
    {
      icon: 'BuildingOffice2Icon',
      value: '200+',
      label: 'Enterprise Clients',
      description: 'Successful transformations delivered',
    },
    {
      icon: 'CurrencyDollarIcon',
      value: '$50M+',
      label: 'Value Created',
      description: 'Cumulative business value generated',
    },
  ];

  return (
    <section className="py-20 lg:py-32 bg-gradient-to-br from-primary/5 to-secondary/5">
      <div className="container mx-auto px-4">
        <div className="max-w-6xl mx-auto">
          <div className="text-center mb-16">
            <h2 className="text-3xl md:text-4xl lg:text-5xl font-bold font-headline text-primary mb-6">
              Proven Track Record
            </h2>
            <p className="text-xl text-muted-foreground font-body max-w-3xl mx-auto">
              Our methodology has delivered measurable results for enterprise organizations across industries.
            </p>
          </div>

          <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-8">
            {metrics?.map((metric, index) => (
              <div
                key={index}
                className="bg-card rounded-xl p-6 text-center shadow-subtle hover:shadow-strong transition-all duration-300 border border-border hover:border-primary/30"
              >
                <div className="w-16 h-16 rounded-full bg-primary/10 flex items-center justify-center mx-auto mb-4">
                  <Icon name={metric?.icon} size={32} variant="solid" className="text-primary" />
                </div>
                <div className="text-4xl font-bold text-primary mb-2">{metric?.value}</div>
                <div className="text-lg font-semibold text-foreground mb-2">{metric?.label}</div>
                <div className="text-sm text-muted-foreground">{metric?.description}</div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default TrustIndicatorsSection;